import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./stores/store-client";
import _ from 'lodash';
// import SuiVue from 'semantic-ui-vue';

// import VueForm from 'vue-form';
import './plugins/bootstrap-vue'
import './plugins/fontawesome'
import 'tachyons/css/tachyons.min.css'

// import 'semantic-ui-css/semantic.min.css';

import './css/app.styl'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// import  vuetron from 'vuetron';

// Vue.use(vuetron.VuetronVue);

window._ = _;

Vue.config.productionTip = false;
// Vue.config.devtools = true;

// Vue.use(VueForm, {});

// Vue.use(SuiVue);

Vue.use(function (Vue) {
  Vue.prototype.$has = _.has
  Vue.prototype.$get = _.get
})


// //IMPORTO ALL FILES IN  DIRECTIVES
function requireAllDirective(requireContext) {
  var keys = requireContext.keys()
  _.forEach(keys, k => {
      var modulo = requireContext(k)
      var nome = k.match(/([^/]*).js$/)
      Vue.directive(nome[1], modulo.default)
  })
}
requireAllDirective(require.context("./directives", true, /^\.\/.*\.js$/));


//IMPORTO ALL FILES IN ELEMENTS AND COMPONENTS
function requireAllComponents(requireContext) {
  var keys = requireContext.keys();
  _.forEach(keys, k => {
      var modulo = requireContext(k)
      var nome = k.match(/([^/]*).vue$/)
      // console.log("registrando "+nome[1])
      // console.log(modulo)
      Vue.component(nome[1], modulo.default)
  })
}


//IMPORTO ALL UTILITS IN window.le.__util
function requireUtil(requireContext) {
  var keys = requireContext.keys();
  window._util = window._util || {}
  _.forEach(keys, k => {
      var modulo = requireContext(k)
      var nome = k.match(/([^/]*).js$/)
      nome = nome[1];

      if (nome.indexOf("array_") == 0) {
          var nomeFuncao = nome.substring(6, 100);
          Array.prototype[nomeFuncao] = modulo.default
      }else{
          var nomeFuncao = nome;
          window._util[nomeFuncao] = modulo.default
      }

  })
}

// console.error("registrando")
requireAllComponents(require.context("@/elements", true, /^\.\/.*\.vue$/));
requireAllComponents(require.context("@/components", true, /^\.\/.*\.vue$/));
requireUtil(require.context("@/util", true, /^\.\/.*\.js$/));



new Vue({
  router,
  store:store(),
  beforeCreate() {
    //debugger;
		// this.$store.commit('initialiseStore');
	},
  render: h => h(App)
}).$mount("#app");
